import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FILTER_CONTROL, FILTER_LABEL } from "./FilterControls";

/**
 * Recherche GLOBALE des écrans d'historique.
 *
 * Remplace le champ unique de chaque barre de filtres (UUID, email…) : on tape un nom, une
 * entreprise, une IP, un produit, et la recherche porte sur toutes ces colonnes à la fois.
 * Plusieurs mots = tous requis (« jean poulailler »).
 *
 * La recherche se fait CÔTÉ SERVEUR, pas en mémoire comme sur la page Produits : les
 * historiques sont paginés par le serveur, une recherche locale ne verrait que les 50
 * lignes affichées.
 *
 * Même rythme que le reste de la barre : la saisie ne part qu'à « Entrée » ou au bouton
 * « Rechercher » — une requête par frappe sur une table de 180 000 lignes serait du
 * gaspillage.
 */
export const HistorySearchInput = ({
  label,
  value,
  placeholder,
  onChange,
  onSubmit,
}: {
  label: string;
  value: string;
  /** Liste les champs cherchés : sans elle, l'utilisateur ne sait pas quoi taper. */
  placeholder: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
}) => (
  // `md:min-w-[18rem]` : c'est LE champ principal de la barre, il doit rester lisible
  // à côté des menus. `flex-1` sous `md` pour qu'il prenne la largeur de l'écran.
  <label className={`${FILTER_LABEL} flex-1 md:flex-none md:min-w-[18rem]`}>
    {label}
    <span className="relative">
      <FontAwesomeIcon
        icon="magnifying-glass"
        className="absolute left-3 top-1/2 h-3 w-3 -translate-y-1/2 text-grey-medium pointer-events-none"
      />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && onSubmit()}
        placeholder={placeholder}
        className={`${FILTER_CONTROL} w-full pl-8`}
      />
    </span>
  </label>
);
